/* eslint-disable @typescript-eslint/no-unsafe-return */
import React from "react"
import { Switch, SwitchProps as MantineSwitchProps } from "@mantine/core"
import { SwitchProps as MUISwitchProps } from "@mui/material"
import withMappedProps from "hoc-lib/propsMapping"

import cx from "classnames"

import styles from "./Switch.mantine.module.scss"

const MantineSwitch = Switch
export default MantineSwitch

const muiToMantine = (props: MUISwitchProps): MantineSwitchProps => {
  const anyProps: any = { ...props }
  return {
    ...anyProps,
    unstyled: true,
    classNames: {
      ...styles,
    },
  }
}

export const MUIMappedSwitch = withMappedProps(MantineSwitch, muiToMantine)
